var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 16.7498C11.8018 16.7508 11.6107 16.6715 11.4708 16.5298L3.47082 8.52985C3.19546 8.23434 3.20359 7.77384 3.4892 7.48823C3.77481 7.20261 4.23531 7.19449 4.53082 7.46985L12.0008 14.9398L19.4708 7.46985C19.7663 7.19449 20.2268 7.20261 20.5124 7.48823C20.7981 7.77384 20.8062 8.23434 20.5308 8.52985L12.5308 16.5298C12.3909 16.6715 12.1999 16.7508 12.0008 16.7498Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottom);
export default __webpack_public_path__ + "static/media/Bottom.3efc6f944ad1e1ad4da458c0d61799ff.svg";
export { ForwardRef as ReactComponent };